<template>
  <div class="download-tip">
    <a-modal
      title="试卷下载"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      okText="下载"
      cancelText="取消"
    >
      <template v-if="config.download_using_questions">
        <div class="download-modal__item">
          <div class="download-modal__item--left">
            试卷类型：
          </div>
          <div class="download-modal__item--right">
            <a-radio-group :options="plainOptions3" @change="onChange3" v-model="value3" />
          </div>
        </div>
        <div class="download-modal__item">
          <div class="download-modal__item--left">
            文件格式：
          </div>
          <div class="download-modal__item--right">
            <a-radio-group :options="plainOptions1" @change="onChange1" v-model="value1" />
          </div>
        </div>
        <div class="download-modal__item">
          <div class="download-modal__item--left">
            试卷内容：
          </div>
          <div class="download-modal__item--right">
            <a-checkbox-group
              v-model="paperContent"
              :options="paperContentOptions"
              @change="onChangePaperContent"
            />
          </div>
        </div>
      </template>
      <template v-if="!config.is_downloaded">
        <p>
          下载需消耗<span class="font-blue font-large">{{ config.costs }}</span
          >个下载券，你当前有<span class="font-blue font-large">{{ couponCount }}</span
          >个下载券
        </p>
        <p class="hint-tip" style="font-size: 12px">*资源可重复下载</p>
      </template>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: this.value,
      plainOptions1: [{ label: 'DOCX-标准版', value: '1' }, { label: 'DOCX-紧凑版', value: '2' }],
      plainOptions3: [
        { label: '普通试卷（答案在卷尾）', value: '1' },
        { label: '教师试卷（答案在题目后）', value: '2' }
      ],
      paperContentOptions: [
        { label: '答案', value: '1' },
        { label: '解析', value: '2' },
        { label: '知识点', value: '3' }
        // { label: '来源', value: '4' }
      ],
      value1: '1',
      value3: '1',
      paperContent: ['1', '2', '3'] // , '4'
    }
  },
  watch: {
    value: function(val) {
      this.visible = val
    }
  },
  props: {
    couponCount: {
      type: Number,
      default: 0
    },
    config: {
      type: Object,
      default: function() {
        return {}
      }
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  methods: {
    handleOk(e) {
      this.$emit('sure', {
        mode: this.value3,
        format: 'docx',
        render_mode: ~~this.value1,
        with_answer: this.paperContent.includes('1'),
        with_analysis: this.paperContent.includes('2'),
        with_knowledge_points: this.paperContent.includes('3'),
        with_paper_origin: this.paperContent.includes('4')
      })
      // window.location.href = '/search/personal/mine'
    },
    handleCancel(e) {
      // console.log('Clicked cancel button')
      this.visible = false
      this.$emit('cancel')
    },
    onChange1() {},
    onChange3() {},
    onChangePaperContent(val) {
      // TODO:
      console.log('onChangePaperContent ' + val)
    }
  },
  mounted() {}
}
</script>
<style lang="scss">
.download-tip {
  .hint-tip {
    width: 190px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(245, 34, 45, 1);
    line-height: 20px;
  }
}
.download-modal__item {
  display: flex;
  margin-bottom: 15px;
}
</style>
